import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Fab,
  DialogActions,
  Tabs,
  Tab,
  Autocomplete
} from "@mui/material";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import Tooltip from "@mui/material/Tooltip";
import { Check as CheckIcon, Clear as ClearIcon, Close, CropSharp, Details, Work } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import styled from "styled-components";
import { ACTIVITY_STATUS, ROLES } from "../../constants";
import moment from "moment";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import { AuthContext } from "../contextAPI/ContextAPI";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';


const isMobile = window.innerWidth < 900;

const TotalAmountTypography = styled(Typography)`
 
  position: absolute;
 
  bottom: 10px;
 
  right: 10px;
 
  font-size: ${isMobile ? "14px" : "inherit"};
 
  bottom: ${isMobile ? "85px" : "70px"};
 
  right: ${isMobile ? "15px" : "70px"};
 
`;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "106px - 20px - 82.23px" : "100px - 20px - 23.77px"}
  // );
  width: ${isMobile ? "100%" : "98%"};
  border: solid 1px lightGrey;
  border-radius: 8px;
  margin-left:${isMobile ? "0px" : "10px"};
  margin-bottom:${isMobile ? "0px" : "10px"};

`;
const InputFieldContainer = styled.div`
  margin: 20px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  label {
    margin-bottom: 0px;
  }
`;
const TabsContainer = styled.div`
  ${isMobile && `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}
`
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;

const ModalActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const FirstButton = styled(Button)`
  margin-right: 10px !important;
`;

const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const StyledDialog = styled(Dialog)`
  position: relative;
`;

const FabStyle = styled(Fab)`
  && {
    z-index: 1;
  }
`;

const DataGridContainer = styled.div`
  width: 100%;
 
 
`;
const DataGridContainer1 = styled.div`
  width: 100%;
  margin-bottom:${!isMobile && "20px"};
 
//   height: 500px;
`;

const NoteText = styled(Typography)`
  margin-top: 10px !important;
`;

const Input = styled.input`
  display: none;
`;


const AttendanceModal = ({ props, onClose, remarks, data, id, distributorId, fetchData, status }) => {
  const [changePassword, setChangePassword] = useState(false)
  const [tabValue, setTabValue] = useState(0);
  const { auth, setAuth } = useContext(AuthContext);

  const [details, setDetails] = useState(data);
  const [startKm, setStartKm] = useState(data);

  const [roles, setRoles] = useState([])
  const [plantCode, setPlantCode] = useState("")
  const [loading, setLoading] = useState(false)
  const [product, setProduct] = useState()
  const [dynamicFields, setDynamicFields] = useState(data?.orderDetails?.map((obj, index) => ({ pricebookentryid: '', name: obj.product_name__c, quantity: obj.quantity, unitprice: obj.unitprice, totalprice: obj.totalprice, oid: obj.orderitemnumber, product2id: obj.product2id, id: index + 1 })));
  const [deletedField, setDeletedFields] = useState([])
  const [hasChanges, setHasChanges] = useState(false);
  const [remark, setRemrak] = useState(remarks)
  const [form, setForm] = useState({})
  const [errors, setErrors] = useState({});
  const [employee, setEmployee] = useState([])
  const [assignedEmp, setAssignedEmp] = useState()
  const [workType, setWorkType] = useState([])
  const [vehicleType, setVehicleType] = useState([])
  const [daType, setDaType] = useState([])
  const [vehicleTypeCheck, setVehicleTypeCheck] = useState(true)
  const [workTypeCheck, setWorkTypeCheck] = useState(true)
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)


  useEffect(() => {
    // if(tabValue===1){
    //   fetchProduct(plantCode,distributorId)
    // }
    if (status === false) {
      // setTabValue(1)
      getDaType()
    }
    else {
      fetchWorkType()
      fetchVehicleType()
    }
    fetchEmployees()
  }, [])

  useEffect(() => {
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers()
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
  }, [])

  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    setAllUsers(results?.data)
    setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
    setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
    setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
  }

  async function getUsers(role, id) {
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setAsms(results?.data)
        setRms(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
      }
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
      }
    }
  }

  const changeHandler = (fieldName, value) => {
    if (fieldName === "startKm" || fieldName === "taExpense" || fieldName === "daExpense" || fieldName === "endKm") {
      const sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 10);
      setForm((prevForm) => ({ ...prevForm, [fieldName]: sanitizedValue }))
    }
    else {
      setForm((prevForm) => ({ ...prevForm, [fieldName]: value }));
    }
  };

  const vehicleTypeHandler = (data) => {
    changeHandler("vehicleType", data)
    if (data === "2 Wheeler" || data === "4 Wheeler") {
      setVehicleTypeCheck(true)
    }
    else {
      setVehicleTypeCheck(false)

    }
  }
  const workTypeHandler = (data) => {
    changeHandler("workType", data)
    if (data === "Full Day Working" || data === "Half Day Working") {
      setWorkTypeCheck(true)
    }
    else {
      setWorkTypeCheck(false)

    }
  }

  const fetchAttendanceById = async (data) => {
    try {
      setLoading(true)
      const response = await window.Platform.database.fetchAttendanceById({ ownerId: data })
      const checkData = response?.data?.workType
      const checkData1 = response?.data?.vehicleType
      setStartKm(response?.data?.startKm);

      if (checkData || checkData1) {
        if (checkData === "Full Day Working" || checkData === "Half Day Working" || checkData1 === "2 Wheeler" || checkData1 === "4 Wheeler") {
          setWorkTypeCheck(true)
        }
        else {
          setWorkTypeCheck(false)

        }
      }
      else {
        setWorkTypeCheck(true)

      }
      setLoading(false)

    }
    catch (err) {
      console.log(err)
    }
  }


  const renderContent1 = () => {
    return (
      // <div style={{ overflowY: "auto" }}>
      <div style={{ maxHeight: "300px", height: "300px", overflowY: "auto" }}>
        {/* <Stack direction={"row"} spacing={2} padding={2}>
          <Autocomplete
            options={employee}
            // getOptionLabel={}
            // getOptionLabel={(option) => `${option?.name} (${option?.id})`}
            getOptionLabel={(option) => `${option?.name}`}
            getOptionValue={(option) => option?.id || ''}
            style={{ width: "100%" }}
            value={assignedEmp}
            // disabled={loading 
            // || !addNewMode || props.isManager
            // }
            noOptionsText={loading ? "Loading..." : "No option"}
            onChange={(event, value) => {
              if (value) {
                changeHandler("ownerId", value.id);
                setAssignedEmp(value);
                fetchAttendanceById(value.id);
              } else {
                changeHandler("ownerId", ""); // or null, as per your logic
                setAssignedEmp(null);
              }
            }}
            onInputChange={(e, value) => {
              // Check if the user's input matches any option
              const matchingOption = employee.find((option) => option.name === value.name);

              if (!matchingOption) {
                // If there's no matching option, set the otherValue to null
                //   setDeliveryCity(null);
                setAssignedEmp();
                return;
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                // disabled={
                //   loading 
                // || !addNewMode || props.isManager || props.isDeleted
                // }
                label={"Attendance Marked For"}
                required
                variant="outlined"
                error={errors.attendanceMarkedFor ? true : false}
              />
            )} />

        </Stack> */}
        <Stack direction={"row"} spacing={2} padding={2}>
          {/* {userData?.role.includes('admin') && <div className="col-md-4">
            <Typography variant="body1" className="ml-5">Select HO</Typography>
            <Select value={rsm} className="ml-2" variant="outlined" size="small" onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
              <MenuItem value="">All</MenuItem>
              {rsms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
            </Select>
          </div>} */}
          {/* {userData?.role.includes('admin') &&  <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
                      <InputLabel id="select-label">Select HO</InputLabel>
                      <Select
                        labelId="select-label"
                        id="select"
                        value={rsm}
                        onChange={(e) =>{ setRsm(e.target.value); getUsers('rsm', e.target.value)} }
                        label="Select HO"
                      >
                        <MenuItem value="">All</MenuItem>
                        {rsms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
                      </Select>
                    </FormControl>} */}
          {/* {userData?.role != 'asm' && <div className="col-md-3 ml-2">
            <Typography variant="body1" className="ml-3">Select ARM</Typography>
            <Select value={asm} variant="outlined" size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
              <MenuItem value="">All</MenuItem>
              {asms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
            </Select>
          </div>} */}
          {/* { userData?.role != 'asm' &&  <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
                      <InputLabel id="select-label">Select ARM</InputLabel>
                      <Select
                        labelId="select-label"
                        id="select"
                        value={asm}
                        onChange={(e) =>{ setAsm(e.target.value); getUsers('asm', e.target.value)} }
                        label="Select ARM"
                      >
                        <MenuItem value="">All</MenuItem>
                        {asms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
                      </Select>
                    </FormControl>} */}
          {/* <div className="col-md-3 ml-3">
            <Typography variant="body1" className="ml-5">Select RM </Typography>
            <Select value={rm} variant="outlined" size="small" onChange={(e) => { setRm(e.target.value); changeHandler("ownerId", e.target.value); getUsers('rm', e.target.value) }} sx={{ width: '100%', fontSize: 14 }}>
              <MenuItem value="">All</MenuItem>
              {rms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
            </Select>
          </div> */}
          {/* <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
                      <InputLabel id="select-label">Select RM</InputLabel>
                      <Select
                        labelId="select-label"
                        id="select"
                        value={rm}
                        onChange={(e) =>{ setRm(e.target.value); changeHandler("ownerId", e.target.value); getUsers('rm', e.target.value)} }
                        label="Select ARM"
                      >
                        <MenuItem value="">All</MenuItem>
                        {rms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
                      </Select>
                    </FormControl> */}
          {userData?.role.includes('admin') && (
            <Autocomplete
              options={rsms}
              // getOptionLabel={(option) => option.name || ""}
              getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
              value={rsms.find((role) => role.id === rsm) || null}
              onChange={(event, value) => {
                setRsm(value ? value.id : "");
                getUsers('rsm', value ? value.id : "");
                setAsm("");
                setRm("");
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  placeholder="Select HO"
                  InputProps={{
                    ...params.InputProps,
                    style: { ...params.InputProps?.style, color: "#222" }, // input text color
                  }}
                  InputLabelProps={{
                    ...params.InputLabelProps,
                    style: { color: "#222" }, // label color
                  }}
                  sx={{
                    '& .MuiInputBase-input::placeholder': {
                      color: '#222', // dark placeholder
                      opacity: 1,
                    },
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              sx={{ width: '100%', fontSize: 14 }}
            />
          )}
          {userData?.role !== 'asm' && (
            <Autocomplete
              options={asms}
              // getOptionLabel={(option) => option.name || ""}
                getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
              value={asms.find((role) => role.id === asm) || null}
              onChange={(event, value) => {
                setAsm(value ? value.id : "");
                setRm("")
                getUsers('asm', value ? value.id : "");
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  placeholder="Select ARM"
                  InputProps={{
                    ...params.InputProps,
                    style: { ...params.InputProps?.style, color: "#222" }, // input text color
                  }}
                  InputLabelProps={{
                    ...params.InputLabelProps,
                    style: { color: "#222" }, // label color
                  }}
                  sx={{
                    '& .MuiInputBase-input::placeholder': {
                      color: '#222', // dark placeholder
                      opacity: 1,
                    },
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              sx={{ width: '100%', fontSize: 14 }}
            />
          )}
          <Autocomplete
            options={rms}
            // getOptionLabel={(option) => option.name || ""}
              getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
            value={rms.find((role) => role.id === rm) || null}
            onChange={(event, value) => {
              setRm(value ? value.id : "");
              getUsers('rm', value ? value.id : "");
              changeHandler('ownerId', value ? value.id : "");
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                size="small"
                placeholder="Select RM"
                InputProps={{
                  ...params.InputProps,
                  style: { ...params.InputProps?.style, color: "#222" }, // input text color
                }}
                InputLabelProps={{
                  ...params.InputLabelProps,
                  style: { color: "#222" }, // label color
                }}
                sx={{
                  '& .MuiInputBase-input::placeholder': {
                    color: '#222', // dark placeholder
                    opacity: 1,
                  },
                }}
              />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            sx={{ width: '100%', fontSize: 14 }}
          />
        </Stack>
        {/* <Stack direction={"row"} spacing={2} padding={2}>
          <FormControl fullWidth required>
            <InputLabel id="select-label" required error={errors.workType ? true : false}>Work Type</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={form.workType}
              onChange={(e) => workTypeHandler(e.target.value)}
              label="Select Option"
              required
              error={errors.workType ? true : false}
            >
              {workType.map((data) => (
                <MenuItem key={data.type} value={data.type}>
                  {data.type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth required>
            <InputLabel id="select-label" required error={errors.vehicleType ? true : false}>Vehicle Type </InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={form.vehicleType}
              onChange={(e) => vehicleTypeHandler(e.target.value)}
              label="Select Option"
              required
              error={errors.vehicleType ? true : false}
              disabled={form.workType === "Work From Home"}
            >
              {vehicleType?.map((option, optionIndex) => (
                <MenuItem key={option.vehicleTypeId} value={option.vehicleTypeName}>
                  {option.vehicleTypeName}
                </MenuItem>
              ))}


            </Select>
          </FormControl>

        </Stack> */}

        <Stack direction={"row"} spacing={2} padding={2}>

          {/* <TextField label="Start KMs" disabled={!vehicleTypeCheck||!workTypeCheck||!form.vehicleType||!form.workType} required value={form?.startKm || ""} type="text"fullWidth onChange={(e)=>changeHandler("startKm",e.target.value)} error={errors.startKm ? true : false}/> */}
          {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              label="Start Time"
              required
              error={errors.in_time}
              value={form.in_time || null}
              onChange={(newValue) => changeHandler("in_time", newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  required
                  error={errors.in_time}
                />
              )}
            />
          </LocalizationProvider> */}
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              label="Start Time"
              required
              value={form.in_time || null}
              onChange={(newValue) => changeHandler("in_time", newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  required
                  error={!!errors.in_time}
                  helperText={errors.in_time || ""}
                   InputProps={{
          ...params.InputProps,
          style: { ...params.InputProps?.style, color: "#000" }, // input text color
        }}
        InputLabelProps={{
          ...params.InputLabelProps,
          style: { color: "#000" }, // label color
        }}
        sx={{
          '& .MuiInputBase-input::placeholder': {
            color: '#000', // placeholder color
            opacity: 1,
          },
        }}
                />
              )}
            />
          </LocalizationProvider>
          <TextField label="Remarks" value={form?.remark || ""} type="text" fullWidth onChange={(e) => changeHandler("remark", e.target.value)} required error={errors?.remark ? true : false} 
            InputProps={{
    style: { color: "#000" }, // input text color
  }}
  InputLabelProps={{
    style: { color: "#000" }, // label color
  }}
  sx={{
    '& .MuiInputBase-input::placeholder': {
      color: '#000', // placeholder color
      opacity: 1,
    },
  }}
  />

        </Stack>


        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: "20px" }}>
          <Button variant="contained" onClick={() => onsubmit(form)} >

            Submit
          </Button>
        </div>


      </div>
    )
  }

  const renderContent = (params) => {
    return (
      // <>
      <div style={{ maxHeight: "300px", height: "300px", overflowY: "auto" }}>
        <Stack direction={"row"} spacing={2} padding={2}>
          {/* <Autocomplete
            options={employee}
            // getOptionLabel={}
            // getOptionLabel={(option) => `${option?.name} (${option?.id})`}
            getOptionLabel={(option) => `${option?.name}`}
            getOptionValue={(option) => option?.id || ''}
            style={{ width: "100%" }}
            value={assignedEmp}
            // disabled={loading 
            // || !addNewMode || props.isManager
            // }
            noOptionsText={loading ? "Loading..." : "No option"}
            onChange={(event, value) => {
              console.log("TEST1212", value)
              changeHandler("ownerId", value?.id)
              setAssignedEmp(value)
              fetchAttendanceById(value?.id)
              //  updateDataGrid(value);

              // if(selectedCity.warehouseCountry === 'India' && warehouseData.attributes.warehouseCountry === 'China')
              // {
              //     setDisableTransfer(false)
              // }
              // else
              // setDisableTransfer(true)



            }}
            onInputChange={(e, value) => {
              // Check if the user's input matches any option
              const matchingOption = employee.find((option) => option.name === value.name);

              if (!matchingOption) {
                // If there's no matching option, set the otherValue to null
                //   setDeliveryCity(null);
                setAssignedEmp();
                return;
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                // disabled={
                //   loading 
                // || !addNewMode || props.isManager || props.isDeleted
                // }
                label={"Attendance Marked For"}
                required
                variant="outlined"
                error={errors.attendanceMarkedFor ? true : false}
              />
            )} /> */}

          {userData?.role.includes('admin') && <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <InputLabel id="select-label">Select HO</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={rsm}
              onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value) }}
              label="Select"
            >
              <MenuItem value="">All</MenuItem>
              {/* {rsms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))} */}
              {rsms.map((role) => (<MenuItem key={role} value={role.id}>{role.name} - {role.username}</MenuItem>))}
            </Select>
          </FormControl>}

          {userData?.role != 'asm' && <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <InputLabel id="select-label">Select ARM</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={asm}
              onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value) }}
              label="Select ARM"
            >
              <MenuItem value="">All</MenuItem>
              {asms.map((role) => (<MenuItem key={role} value={role.id}>{role.name} - {role.username}</MenuItem>))}
              {/* {asms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))} */}
            </Select>
          </FormControl>}

          <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <InputLabel id="select-label">Select RM</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={rm}
              onChange={(e) => { setRm(e.target.value); changeHandler("ownerId", e.target.value);}}
              label="Select ARM"
            >
              <MenuItem value="">All</MenuItem>
              {/* {rms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))} */}
              {rms.map((role) => (<MenuItem key={role} value={role.id}>{role.name} - {role.username}</MenuItem>))}
            </Select>
          </FormControl>
        </Stack>

        {/* <Stack direction={"row"} spacing={2} padding={2}>
          <TextField label="End Kms" disabled={!workTypeCheck || !form.ownerId} value={form?.endKm || ""} type="text" fullWidth
            error={errors.endKm ? true : false}
            helperText={errors.endKm || ""}
            onChange={async (e) => {
              const inputValue = e.target.value;


              changeHandler("endKm", inputValue);
            }

            }

          />

          <FormControl fullWidth required>
            <InputLabel id="select-label" required error={errors?.daType ? true : false}>DA Type</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={form?.workType}
              onChange={(e) => changeHandler("daType", e.target.value)}
              label="Select Option"
              required
              error={errors?.daType ? true : false}
            >
              {daType.map((data) => (
                <MenuItem key={data?.daTypeId} value={data?.daType}>
                  {data?.daType}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack> */}


        {/* <Stack direction={"row"} spacing={2} padding={2}>
          <TextField label="Mention Town Name" value={form?.townName || ""} required type="text" fullWidth onChange={(e) => changeHandler("townName", e.target.value)} error={errors?.townName ? true : false} />

          <TextField label="Remarks" value={form?.endDetails} type="text" fullWidth onChange={(e) => changeHandler("endDetails", e.target.value)} />
        </Stack> */}

        <Stack direction={"row"} spacing={2} padding={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              label="End Time"
              value={form.out_time || null}
              onChange={(newValue) => changeHandler("out_time", newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  required
                  error={!!errors.out_time}
                />
              )}
            />
          </LocalizationProvider>
          <TextField label="Remarks" value={form?.remark || ""} type="text" fullWidth onChange={(e) => changeHandler("remark", e.target.value)} required error={errors?.remark ? true : false} />
        </Stack>



        {/* </Box> */}
        {/* </DataGridContainer> */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
          <Button variant="contained" onClick={() => onsubmit(form)} >

            End Day
          </Button>
        </div>
      </div>
    );
  };

  const fetchEmployees = async (data) => {
    const results = await window.Platform.database.getUsersForWork(data);
    setEmployee(results.data)
  }

  const fetchVehicleType = async (data) => {
    const results = await window.Platform.database.getVehicleType(data);
    setVehicleType(results.data)
  }

  const getDaType = async (data) => {
    const results = await window.Platform.database.getDaType(data);
    setDaType(results.data)
  }

  const validateForm = (data, day) => {
    const errors = {};

    if (day === "end") {
      // if (!data.ownerId?.trim()) {
      //   errors.attendanceMarkedFor = "Attendance marking is required";
      // }

      // if (!workTypeCheck || !form.ownerId) {
      //   return
      // } else {
      //   if (!data.endKm?.trim()) {
      //     errors.endKm = "End KM is required";
      //   }
      // }

      // if (!data.daType?.trim()) {
      //   errors.daType = "DA type is required";
      // }

      // if (!data.townName?.trim()) {
      //   errors.townName = "Town name type is required";
      // }

      // if (data.endKm) {
      //   if (Number(data.endKm?.trim()) < startKm) {
      //     errors.endKm = "End km should be greater than start km";
      //   }
      // }
      if (!data.out_time) {
        errors.out_time = "Start Time is required";
      }
      // if (!data.remark) {
      //   errors.startKm = "Remark is required";
      // }
      if (!(data.remark || "").trim()) {
        errors.remark = "Remark is required";
      }
      if (!data.ownerId?.trim()) {
        errors.attendanceMarkedFor = "Attendance marking is required";
      }
    } else {
      if (!data.ownerId?.trim()) {
        errors.attendanceMarkedFor = "Attendance marking is required";
      }
      if (!(data.remark || "").trim()) {
        errors.remark = "Remark is required";
      }
      if (!data.in_time) {
        errors.in_time = "Start Time is required";
      }
    }

    return errors;
  };


  const onsubmit = async (data) => {
    try {
      setLoading(true)
      if (status) {
        const errors = validateForm(data, "start");
        setErrors(errors);
        if (Object.keys(errors).length === 0) {
          data['punch'] = 'in'
          data['userId'] = data.ownerId
          const results = await window.Platform.database.startAttendance(data);
          if (results.status) {
            setLoading(false)
            window.NotificationUtils.showError(results.message)

            return
          }
          else {
            window.NotificationUtils.showSuccess(results?.message);
            setLoading(false)
            onClose()
            fetchData()
          }
        } else {
          setLoading(false);
          window.NotificationUtils.showError("Please fill the form correctly.");
        }

      }
      else {
        const errors = validateForm(data, "end");
        setErrors(errors);

        if (Object.keys(errors).length === 0) {
          data['punch'] = 'out'
          data['userId'] = data.ownerId
          const results = await window.Platform.database.startAttendance(data);
          if (results.status) {
            window.NotificationUtils.showError(results.message);
            setLoading(false)
            return;
          } else {
            window.NotificationUtils.showSuccess(results?.message);
            setLoading(false);
            onClose();
            fetchData();
          }
        } else {
          setLoading(false);
          window.NotificationUtils.showError("Please fill the form correctly.");
        }

      }


    }
    catch (error) {
      console.log(error)
      setLoading(false)

    }
  }

  const fetchPinCode = async (details) => {
    try {
      setLoading(true)
      let results = await window.Platform.database.fetchPinCode(details);
      setForm({ ...form, state: results.data[0].StateName, district: results.data[0].District })
      setLoading(false)

      // setDetails(results.data[0]);
      // setProduct(results.data)
    }
    catch (err) {
      console.log(err);
      setLoading(false)

    }
  }

  const fetchWorkType = async (details) => {
    try {
      setLoading(true)
      let results = await window.Platform.database.getWorkType(details);
      setWorkType(results.data)
      setLoading(false)

      // setDetails(results.data[0]);
      // setProduct(results.data)
    }
    catch (err) {
      console.log(err);
      setLoading(false)

    }
  }


  return (
    <Dialog disableEnforceFocus maxWidth="lg" fullWidth={true} open={true} >
      {loading && <OpaqueLoading />}
      <ModalHeaderContainer style={{ marginBottom: 2, paddingBottom: 3 }}>
        <Typography variant={isMobile ? "h6" : "h5"}>
          Attendance
          <Tooltip title="Order Id">

            {id}
          </Tooltip>

        </Typography>
        <IconButton onClick={onClose} >
          <CloseOutlined />
        </IconButton>
      </ModalHeaderContainer>
      <TableContainer>

        <TabsContainer>
          <StyledTabs
            variant="fullWidth"
            value={tabValue}

            // onChange={ handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
          >
            {status ? <Tab label="Start Day" /> :
              <Tab label="End Day" />}

          </StyledTabs>
          {!status && renderContent()}
          {status && renderContent1()}


        </TabsContainer>

      </TableContainer>

    </Dialog>
  );
};

export default AttendanceModal;